import React from "react";
import { useExtLabels } from './extLabels'


const SummaryPage = ({ token, title }) => {
    const l = useExtLabels()

    return (
        <React.Fragment>
            <h2>
                {l('Dziękujemy za zgłoszenie do konkursu')} <strong>{title}</strong>.
            </h2>
            <p>
                {l('Zgłoszenie jest ważne po uiszczeniu opłaty za fakturę proforma. Organizator skontaktuje się z Państwem w najbliższym czasie.')}
            </p>

            <p>
                {l('Z poważaniem,')}
                <br />
                {l('Organizator konkursu')} {title}
            </p>
            {token && (
                <p>
                    {l('Kod zgłoszenia')}: <strong>{token}</strong>
                </p>
            )}
        </React.Fragment>
    );
};

export default SummaryPage;
